(function () {
  'use strict';

  function replaceText(root, replacements) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    while (walker.nextNode()) {
      var node = walker.currentNode;
      var current = node.nodeValue || '';
      var next = current;

      for (var i = 0; i < replacements.length; i += 1) {
        next = next.split(replacements[i][0]).join(replacements[i][1]);
      }

      if (next !== current) node.nodeValue = next;
    }
  }

  function patchPopiaPage() {
    var root = document.getElementById('popia_page');
    if (!root) return;

    replaceText(root, [
      ['pmcjewellery@gmail.com', 'sales@pmctechlife.co.za'],
      ['Data Protection Officer (DPO)', 'Information Officer'],
      ['2 Heleza Boulevard, 4320 uMhlanga KwaZulu-Natal, South Africa', '2 Heleza Boulevard, uMhlanga, KwaZulu-Natal, 4320, South Africa']
    ]);

    var oldMailLinks = root.querySelectorAll('a[href^="mailto:pmcjewellery@gmail.com"]');
    for (var i = 0; i < oldMailLinks.length; i += 1) {
      oldMailLinks[i].setAttribute('href', 'mailto:sales@pmctechlife.co.za');
    }
  }

  function patchContactPolicy() {
    var root = document.querySelector('.contact-content');
    if (!root) return;

    replaceText(root, [
      ['Physical Address:', 'Administrative office:'],
      [' (Text/Chat only)', ''],
      ['(Text/Chat only)', '']
    ]);

    var list = root.querySelector('ul');
    if (!list || /not a walk-in retail store/i.test(root.textContent || '')) return;

    var item = document.createElement('li');
    item.className = 'pmc-administrative-office-note';
    item.textContent = 'Administrative office. This is not a walk-in retail store, collection point or returns address.';

    var hours = null;
    var items = list.children;
    for (var i = 0; i < items.length; i += 1) {
      if (/Operating Hours:/i.test(items[i].textContent || '')) {
        hours = items[i];
        break;
      }
    }

    if (hours) list.insertBefore(item, hours);
    else list.appendChild(item);
  }

  function demoteTrackingAppHeading() {
    if (!document.body || document.body.getAttribute('data-page-handle') !== 'order-tracking') return;

    var titles = document.querySelectorAll('h1.pp_tracking_title');
    for (var i = 0; i < titles.length; i += 1) {
      var title = titles[i];
      var replacement = document.createElement('h2');

      for (var j = 0; j < title.attributes.length; j += 1) {
        replacement.setAttribute(title.attributes[j].name, title.attributes[j].value);
      }

      replacement.setAttribute('data-pmc-heading-level', '2');
      while (title.firstChild) replacement.appendChild(title.firstChild);
      title.replaceWith(replacement);
    }
  }

  function watchTrackingAppHeading() {
    if (!document.body || document.body.getAttribute('data-page-handle') !== 'order-tracking') return;
    if (document.body.hasAttribute('data-pmc-tracking-heading-watch')) return;

    document.body.setAttribute('data-pmc-tracking-heading-watch', 'true');
    demoteTrackingAppHeading();

    var main = document.getElementById('MainContent');
    if (!main) return;

    var observer = new MutationObserver(function () {
      demoteTrackingAppHeading();
    });

    observer.observe(main, { childList: true, subtree: true });
  }

  function initPopiaRequests() {
    var root = document.getElementById('popia_page');
    if (!root || root.hasAttribute('data-pmc-popia-enhanced')) return;

    root.setAttribute('data-pmc-popia-enhanced', 'true');

    var requests = [
      { suffix: 'edit-account', type: 'customer/edit' },
      { suffix: 'requests', type: 'customer/requests' },
      { suffix: 'personal-information', type: 'customer/personal_info' },
      { suffix: 'orders', type: 'customer/orders' },
      { suffix: 'personal-data-report', type: 'customer/report' },
      { suffix: 'delete-account', type: 'customer/delete' }
    ];
    var activeRequest = null;
    var previousOverflow = '';

    var status = document.createElement('p');
    status.className = 'pmc-popia-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('tabindex', '-1');
    status.hidden = true;

    var introduction = root.firstElementChild;
    if (introduction && introduction.nextSibling) {
      root.insertBefore(status, introduction.nextSibling);
    } else {
      root.insertBefore(status, root.firstChild);
    }

    var modal = document.createElement('div');
    modal.className = 'pmc-popia-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="pmc-popia-dialog" role="dialog" aria-modal="true" aria-labelledby="pmc-popia-dialog-title" aria-describedby="pmc-popia-dialog-copy">' +
        '<h2 id="pmc-popia-dialog-title">Confirm your privacy request</h2>' +
        '<p id="pmc-popia-dialog-copy">Consentmo will receive your email address and network information only to process this request. Read <a href="https://www.consentmo.com/end-user-dpa" target="_blank" rel="noopener">Consentmo\'s end-user data processing policy</a>.</p>' +
        '<label class="pmc-popia-consent"><input type="checkbox"><span>I consent to this information being collected and used to process my request.</span></label>' +
        '<div class="pmc-popia-modal__actions">' +
          '<button type="button" class="pmc-popia-cancel">Cancel</button>' +
          '<button type="button" class="pmc-popia-submit" disabled>Submit request</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    var dialog = modal.querySelector('.pmc-popia-dialog');
    var consent = modal.querySelector('input[type="checkbox"]');
    var cancel = modal.querySelector('.pmc-popia-cancel');
    var submit = modal.querySelector('.pmc-popia-submit');

    function setStatus(message, state) {
      status.textContent = message;
      status.hidden = false;
      if (state) status.setAttribute('data-state', state);
      else status.removeAttribute('data-state');
    }

    function collapseAll() {
      for (var i = 0; i < requests.length; i += 1) {
        var item = requests[i];
        var button = document.getElementById('btn-popia-' + item.suffix + '-request');
        var panel = document.getElementById('form-popia-' + item.suffix + '-request');
        if (button) button.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.hidden = true;
          panel.style.display = 'none';
        }
      }
    }

    function closeModal(restoreFocus) {
      modal.hidden = true;
      document.body.style.overflow = previousOverflow;
      consent.checked = false;
      submit.disabled = true;
      submit.textContent = 'Submit request';

      if (restoreFocus && activeRequest && activeRequest.button) {
        activeRequest.button.focus();
      }
    }

    function openModal(request) {
      activeRequest = request;
      previousOverflow = document.body.style.overflow;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      consent.focus();
    }

    function submitRequest(request) {
      if (!window.Shopify || !Shopify.shop) {
        return Promise.reject(new Error('Store details are unavailable.'));
      }

      return fetch('https://www.cloudflare.com/cdn-cgi/trace', {
        method: 'GET',
        headers: { 'Content-Type': 'text/plain' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Network verification failed.');
          return response.text();
        })
        .then(function (networkInfo) {
          var formData = new FormData();
          var translatedLocale = '';

          try {
            if (window.isenseGDPR && isenseGDPR.Cookies && typeof isenseGDPR.Cookies.get === 'function') {
              translatedLocale = isenseGDPR.Cookies.get('googtrans') || '';
            }
          } catch (error) {
            translatedLocale = '';
          }

          formData.append('shop', Shopify.shop);
          formData.append('email', request.email);
          formData.append('type', request.type);
          formData.append('sourceOfRequest', 1);
          formData.append('ipAddress', networkInfo);
          formData.append('consentGiven', true);
          formData.append('page', 'popia');
          formData.append('lang', Shopify.locale || '');
          formData.append('gtranslateLang', translatedLocale);

          return fetch('https://gdpr.apps.isenselabs.com/gdprRequests/submitRequest', {
            method: 'POST',
            body: formData
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('The privacy service did not accept the request.');
          return response.json();
        })
        .then(function (response) {
          if (response.error) throw new Error(response.message || 'The request could not be submitted.');
          return response;
        });
    }

    collapseAll();

    for (var i = 0; i < requests.length; i += 1) {
      (function (item) {
        var button = document.getElementById('btn-popia-' + item.suffix + '-request');
        var panel = document.getElementById('form-popia-' + item.suffix + '-request');
        if (!button || !panel) return;

        var form = panel.querySelector('form');
        var email = panel.querySelector('input[type="email"]');

        button.setAttribute('type', 'button');
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('aria-expanded', 'false');
        panel.setAttribute('role', 'region');
        panel.setAttribute('aria-labelledby', button.id);

        button.addEventListener('click', function () {
          var shouldOpen = button.getAttribute('aria-expanded') !== 'true';
          collapseAll();

          if (shouldOpen) {
            button.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            panel.style.display = 'block';
            if (email) email.focus();
          }
        });

        if (form && email) {
          form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (!form.checkValidity()) {
              form.reportValidity();
              return;
            }

            openModal({
              button: button,
              panel: panel,
              email: email.value.trim(),
              type: item.type
            });
          });
        }
      })(requests[i]);
    }

    consent.addEventListener('change', function () {
      submit.disabled = !consent.checked;
    });

    cancel.addEventListener('click', function () {
      closeModal(true);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal(true);
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(true);
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = dialog.querySelectorAll('a[href], input:not([disabled]), button:not([disabled])');
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    submit.addEventListener('click', function () {
      if (!activeRequest || !consent.checked) return;

      submit.disabled = true;
      submit.textContent = 'Submitting…';
      setStatus('Submitting your privacy request…');

      submitRequest(activeRequest)
        .then(function (response) {
          var message = response.message || 'Your request has been submitted. Check your email for the next step.';
          closeModal(false);
          collapseAll();
          setStatus(message, 'success');
          status.focus();
        })
        .catch(function () {
          closeModal(false);
          setStatus('We could not submit the request. Please try again or email sales@pmctechlife.co.za for help.', 'error');
          status.focus();
        });
    });
  }

  function patch() {
    patchPopiaPage();
    patchContactPolicy();
    initPopiaRequests();
    watchTrackingAppHeading();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch, { once: true });
  } else {
    patch();
  }

  window.addEventListener('load', patch, { once: true });
  document.addEventListener('shopify:section:load', patch);
})();
